import { render, staticRenderFns } from "./wrightinTwo.vue?vue&type=template&id=03b4623b&scoped=true&"
import script from "./wrightinTwo.vue?vue&type=script&lang=js&"
export * from "./wrightinTwo.vue?vue&type=script&lang=js&"
import style0 from "./wrightinTwo.vue?vue&type=style&index=0&id=03b4623b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b4623b",
  null
  
)

export default component.exports